import React from 'react'
import styles from '../styles.module.css'
import { METRICS_TOP, METRICS_MONITORING, MONITORING_SECTION_TITLE, fmt } from './metrics'


const OrgTable = ({ row, academicYear }) => {
  const yearTitle = academicYear
    ? `в ${academicYear} учебном году`
    : 'за учебный год'

  return (
    <table className={styles.mainTable}>
      <thead>
        <tr className={styles.titleRow}>
          <th className={styles.titleLeft}>
            {`Сведения об успеваемости и качестве учебы ${yearTitle}`}
          </th>
          <th className={styles.titleRight}>Форма №2/СВУ</th>
        </tr>
        <tr className={`${styles.titleRow} ${styles.secondTitleRow}`}>
          <th className={styles.titleLeft}>{row.organizationName}</th>
          <th className={styles.titleRight}>Таблица №1</th>
        </tr>
      </thead>
      <tbody>
        {METRICS_TOP.map(m => (
          <tr key={m.key}>
            <td>{m.label}</td>
            <td className={styles.valueCell}>{fmt(row[m.key])}</td>
          </tr>
        ))}
        <tr className={styles.sectionRow}>
          <td colSpan={2}>{MONITORING_SECTION_TITLE}</td>
        </tr>
        {METRICS_MONITORING.map(m => (
          <tr key={m.key}>
            <td>{m.label}</td>
            <td className={styles.valueCell}>{fmt(row[m.key])}</td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}


const Table = ({ data }) => {
  if (!data) return null

  const rows = data.rows || []
  if (!rows.length) {
    return <div className={styles.noData}>Данные отсутствуют</div>
  }

  return (
    <div className={styles.tableBlock}>
      {rows.map(row => (
        <div key={row.organizationId} className={styles.orgBlock}>
          <OrgTable row={row} academicYear={data.academicYear} />
        </div>
      ))}
    </div>
  )
}

export default Table
